import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { MfaFlow } from "@/components/admin/MfaFlow";

export const Route = createFileRoute("/_authenticated/seguridad/mfa")({
  head: () => ({
    meta: [
      { title: "Verificación en dos pasos | Mostrando México" },
      { name: "description", content: "Protege tu cuenta administrativa con verificación en dos pasos." },
      { property: "og:title", content: "Verificación en dos pasos | Mostrando México" },
      { property: "og:description", content: "Seguridad de la cuenta administrativa." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: MfaPage,
});

function MfaPage() {
  const done = useCallback(() => window.location.replace("/admin"), []);
  return <MfaFlow onVerified={done} />;
}
